// src/features/dashboard/services/Employee/weeklyHoursChart.service.ts

import apiClient from '../../../../api/apiService';

import { ENDPOINTS } from '../../../../api/endpoints';

import type {
  WeeklyHoursRequest,
  WeeklyHoursResponse,
} from '../../types/Employee/weeklyHoursChart.types';

export const getWeeklyHoursChart =
  async (
    payload: WeeklyHoursRequest,
  ): Promise<WeeklyHoursResponse> => {

    const token =
      sessionStorage.getItem('token') ||
      localStorage.getItem('token');

    const response =
      await apiClient.post(
        ENDPOINTS.EMPLOYEE_WEEKLY_HOURS_VS_TARGET,
        payload,
        {
          headers: {
            Authorization:
              token
                ? `Bearer ${token}`
                : '',
          },
        },
      );

    return response.data;
  };